import React, { Component } from "react";
import Navbar from "@/modules/Navbar";
import FixedBtn from "@succ/components/FixedBtn";
import Banner from "@succ/components/Banner";
import Countdown from "@/modules/Countdown";
import Tutors from "@succ/components/Tutors";
import Prizes from "@succ/components/Prizes";
import ScrollButton from "@succ/components/ScrollButton";
import Theme from "@succ/components/Theme";
import Description from "@/modules/Description";
import CardListWithTitle from "@/modules/CardListWithTitle";
import CardList from "@/modules/CardList";
import Timeline from "@/modules/Timeline";
import TwoColumns from "@/modules/TwoColumns";
import Faq from "@/modules/Faq";
import Contact from "@/modules/Contact";
import Footer from "@/modules/Footer";
import Application from '@/modules/Application';
import Partners from '@/modules/Partners';
import Message from '@succ/message/message_tw'
import { getPartners } from '@succ/message/message_tw'
import Translator from '@/modules/translator';
import { $t } from '@/modules/i18n';
import "@succ/views/TwApp.scss";

const collectionId = 330;

class App extends Component {
  constructor(props) {
    super(props);
    this.url = "https://careers.shopee.tw/succ/";
    this.imageURL = "http://careers.shopee.tw/succ/images/cover.jpg";
    this.state = {
      message: Message(),
    }
    this.countDownWrapper = React.createRef()
    this.countDownRect = {}
  }

  getHelmetScript() {
    const message = this.state.message.application;

    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: 'Shopee Ultimate Case Challenge 2021',
        description: message.desc,
        image: this.imageURL,
        startDate: message.startDate,
        endDate: message.endDate,
        url: this.url,
        audience: {
          audienceType: "Students passionate about problem solving"
        },
        location: {
          "@type": "Place",
          name: "Shopee Taiwan",
          address: "recruit.tw@shopee.com",
        }
      })
    }]
  }

  calcCountDownInfo() {
    if (!this.countDownWrapper) {
      return
    }
    const rect = this.countDownWrapper.current.getBoundingClientRect()
    this.countDownRect = rect
  }

  initPartnerData() {
    getPartners().then(partners => {
      this.setState({ partners });
    })
  }

  componentDidMount() {
    const { hash } = window.location
    if (hash) {
      const target = document.getElementById(hash.split('#')[1])
      if (target) {
        setTimeout(() => {
          window.scrollTo(0, target.getBoundingClientRect().top)
        }, 0);
      }
    }
    this.initPartnerData()
    this.calcCountDownInfo()
  }

  render() {
    let Message = this.state.message;
    const script = this.getHelmetScript();
    const partners = JSON.stringify(this.state.partners) === '{}' ? null : this.state.partners;
    return (
      <div className="App TW">
        <Application message={Message.application} url={this.url} imageURL={this.imageURL} script={script} viewport={false} />
        <Navbar message={Message.navbar} />
        <ScrollButton scrollStepInPx="150" delayInMs="0.66" />
        <FixedBtn showTop={this.countDownRect.top}>
          <a className="btn-sigh-up" href={Message.sighUpBtn.sighUpLink} target="_blank" rel="noopener noreferrer">{$t(Message.sighUpBtn.btnText)}</a>
        </FixedBtn>
        <Banner message={Message.banner} />
        <section id="countdown" ref={this.countDownWrapper}>
          <Countdown endDate={new Date($t(Message.countDown))} />
        </section>
        <Description message={Message.about} id="about" />
        <CardListWithTitle id="aim" message={Message.aim} />
        <section id="question">
          <CardList list={Message.aim.cardList} />
        </section>
        <section id="prizes" className="prizes-wrapper">
          <Prizes className="prizes" message={Message.prizes} />
        </section>
        <Theme message={Message.theme} />
        <div className="timeline">
          <Timeline message={Message.timeline} />
        </div>
        <section id="tutors">
          <Tutors message={Message.tutors} />
        </section>
        <Faq message={Message.faqs} />
        <Partners message={partners} />
        <section className="partnership-oppo">
          <h2 className="section-title">{$t(Message.chance.title)}</h2>
          <TwoColumns message={Message.chance.list} />
          <p className="partnership-explain">{$t(Message.chance.explain)}</p>
        </section>
        <div className="contact-wrapper">
          <span className="contact-deco-left"></span>
          <Contact message={Message.contact} />
          <span className="contact-deco-right"></span>
        </div>
        <Footer message={Message.footer} />
      </div>
    );
  }
}

export default Translator(App, Message, {}, { collectionId });
